import React, { useEffect, useState } from 'react';
import { IoBagHandle, IoPieChart, IoPeople, IoCart, IoWarningOutline, IoSaveOutline, IoScanCircle, IoTimerOutline, } from 'react-icons/io5'
import { FcExpired } from 'react-icons/fc';
import { IoIosHelpCircleOutline, IoMdClose } from 'react-icons/io'
import axios from 'axios';
import { api_url } from '../../../config';
import { useSelector } from 'react-redux';
import { ColorRing } from 'react-loader-spinner';
import api from '../../../utils/api';
import { TbClockExclamation } from "react-icons/tb";
import { FaBoxOpen } from "react-icons/fa6";
import { PiChartLineDownDuotone } from "react-icons/pi";
import { BsPrescription } from "react-icons/bs";
import { useNavigate } from 'react-router-dom';



const ManagementInfo = () => {
    const [summary, setSummary] = useState([]);
    const navigate = useNavigate();
    const { id, branch_id, token } = useSelector((state) => state.auth);
    const [loader, setLoader] = useState(false)



    useEffect(() => {
        const fetchSummary = async () => {
            try {
                setLoader(true)
                const response = await api.get(`${api_url}/api/v1/retailer/user/${id}/branch/${branch_id}/executive/summary`, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                });
                // console.log('Executive Summary API Response:', response.data);
                // console.log('Executive Summary Data:', response.data.data);
                // console.log('Executive Prescription Statuses:', response.data.data?.prescription_statuses);
                setSummary(response.data.data);
            } catch (error) {
                console.error('Error fetching executive summary:', error);
            } finally {
                setLoader(false)
            }
        };

        fetchSummary();
    }, [id, branch_id, token]);

    return (
        <div className='grid w-full grid-cols-2 gap-4 p-4 border-b font-lufga border-slate-200 md:grid-cols-3 lg:grid-cols-4 3xl:grid-cols-8'>

            <div className="flex items-center justify-center gap-2 p-2 duration-300 rounded-md shadow-md cursor-pointer bg-sky-100 sm:p-4 hover:scale-105 md:gap-6">
                <div><IoBagHandle size={44} className='p-2 text-white rounded-full bg-sky-500 ' /></div>
                <div className='flex flex-col text-xs sm:text-sm '>
                    <p className='font-light text-black 2xl:px-2'>Suppliers</p>
                    <div className='flex items-center mx-auto space-x-1 sm:space-x-2'>
                        {loader ? <ColorRing
                            height="40"
                            width="40"
                            ariaLabel="color-ring-loading"
                            wrapperStyle={{}}
                            wrapperClass="color-ring-wrapper"
                            colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                        /> : <p className='text-lg font-semibold text-gray-700'>{summary?.supplier_count || 0}</p>
                        }
                        {/* <p className='text-sm font-semibold text-green-500'>+2</p> */}
                    </div>
                </div>
            </div>



            {/* <div className="flex items-center justify-center gap-2 p-2 duration-300 bg-white shadow-md sm:p-4 hover:scale-105 md:gap-6">
            <div><IoPeople size={44} className='p-2 text-white bg-yellow-400 rounded-full ' /></div>
            <div className='flex flex-col text-xs sm:text-sm '>
                <p className='font-light text-gray-500 2xl:px-2'>Users</p>
                <div className='flex items-center mx-auto space-x-1 sm:space-x-2'>
                    <p className='text-lg font-semibold text-gray-700'>0</p>
                </div>
            </div>
        </div> */}
            <div className="flex items-center justify-center gap-2 p-2 duration-300 bg-green-100 rounded-md shadow-md sm:p-4 hover:scale-105 md:gap-6">
                <div><IoCart size={44} className='p-2 text-white bg-green-600 rounded-full ' /></div>
                <div className='flex flex-col text-xs sm:text-sm '>
                    <p className='font-light text-black 2xl:px-2'>Pending orders</p>
                    <div className='flex items-center mx-auto space-x-1 sm:space-x-2'>
                        <p className='text-lg font-semibold text-gray-700'>{summary?.pending_orders || 0}</p>
                        {/* <p className='text-sm font-semibold text-green-500'>+2</p> */}
                    </div>
                </div>
            </div>
            <div className="flex items-center justify-center gap-2 p-2 duration-300 rounded-md shadow-md bg-sky-200 sm:p-4 hover:scale-105 md:gap-6">
                <div><IoTimerOutline size={44} className='p-2 text-white rounded-full bg-sky-500 ' /></div>
                <div className='flex flex-col text-xs sm:text-sm '>
                    <p className='font-light text-black 2xl:px-2'>Expiring soon</p>
                    <div className='flex items-center mx-auto space-x-1 sm:space-x-2'>
                        {loader ? <ColorRing
                            height="40"
                            width="40"
                            ariaLabel="color-ring-loading"
                            wrapperStyle={{}}
                            wrapperClass="color-ring-wrapper"
                            colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                        /> : <p className='text-lg font-semibold text-gray-700'>{summary?.expiring_soon || 0}</p>
                        }
                        {/* <p className='text-sm font-semibold text-green-500'>+2</p> */}
                    </div>
                </div>
            </div>
            <div className="flex items-center justify-center gap-2 p-2 duration-300 bg-red-200 rounded-md shadow-md sm:p-4 hover:scale-105 md:gap-6">
                <div><TbClockExclamation size={44} className='p-2 text-white bg-red-800 rounded-full ' /></div>
                <div className='flex flex-col text-xs sm:text-sm '>
                    <p className='font-light text-black 2xl:px-2'>Expired</p>
                    <div className='flex items-center mx-auto space-x-1 sm:space-x-2'>
                        {loader ? <ColorRing
                            height="40"
                            width="40"
                            ariaLabel="color-ring-loading"
                            wrapperStyle={{}}
                            wrapperClass="color-ring-wrapper"
                            colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                        /> : <p className='text-lg font-semibold text-gray-700'>{summary?.expired || 0}</p>
                        }
                        {/* <p className='text-sm font-semibold text-green-500'>+2</p> */}
                    </div>
                </div>
            </div>
            <div className="flex items-center justify-center gap-2 p-2 duration-300 bg-gray-400 rounded-md shadow-md sm:p-4 hover:scale-105 md:gap-6">
                <div><FaBoxOpen size={44} className='bg-[#272829] p-2 text-white rounded-full ' /></div>
                <div className='flex flex-col text-xs sm:text-sm '>
                    <p className='font-light text-black 2xl:px-2'>Out of stock</p>
                    <div className='flex items-center mx-auto space-x-1 sm:space-x-2'>
                        {loader ? <ColorRing
                            height="40"
                            width="40"
                            ariaLabel="color-ring-loading"
                            wrapperStyle={{}}
                            wrapperClass="color-ring-wrapper"
                            colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                        /> : <p className='text-lg font-semibold text-gray-700'>{summary?.out_of_stock || 0}</p>}
                        {/* <p className='text-sm font-semibold text-green-500'>+2</p> */}
                    </div>
                </div>
            </div>
            <div className="flex items-center justify-center gap-2 p-2 duration-300 bg-yellow-100 rounded-md shadow-md sm:p-4 hover:scale-105 md:gap-6">
                <div><PiChartLineDownDuotone size={44} className='bg-[#FFC107] p-2 text-white rounded-full ' /></div>
                <div className='flex flex-col text-xs sm:text-sm '>
                    <p className='font-light text-black 2xl:px-2'>Low on stock</p>
                    <div className='flex items-center mx-auto space-x-1 sm:space-x-2'>
                        {loader ? <ColorRing
                            height="40"
                            width="40"
                            ariaLabel="color-ring-loading"
                            wrapperStyle={{}}
                            wrapperClass="color-ring-wrapper"
                            colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                        /> : <p className='text-lg font-semibold text-gray-700'>{summary?.low_on_stock || 0}</p>
                        }
                    </div>
                </div>
            </div>

            <div className="flex items-center justify-center gap-2 p-2 duration-300 bg-purple-100 rounded-md shadow-md sm:p-4 hover:scale-105 md:gap-6">
                <div><BsPrescription size={44} className='p-2 text-white bg-purple-600 rounded-full' /></div>
                <div className='flex flex-col text-xs sm:text-sm '>
                    <p className='font-light text-black 2xl:px-2'>Pending Prescriptions</p>
                    <div className='flex items-center mx-auto space-x-1 sm:space-x-2'>
                        {loader ? <ColorRing
                            height="40"
                            width="40"
                            ariaLabel="color-ring-loading"
                            wrapperStyle={{}}
                            wrapperClass="color-ring-wrapper"
                            colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                        /> : <p className='text-lg font-semibold text-gray-700'>{summary?.prescription_statuses?.pending || '0'}</p>
                        }
                    </div>
                </div>
            </div>

        </div>
    );
}

export default ManagementInfo;